/* @flow */

import { Map } from 'immutable'

const initial = Map({
  locale: 'de',
  customerType: 'private',
  login: true,
  loginType: 'iban',
  subject: [],
  comment: '',
  consulting: ''
})

export default initial

// export default initial.merge(
//   Map({
//     gender: 'male',
//     firstName: 'philip',
//     lastName: 'lehmann',
//     email: 'philip@at-point.ch',
//     phone: '0797562627',
//     street: 'richterwis 12',
//     zip: '8303',
//     city: 'bassersdorf',
//     birthDate: '1986-09-16',
//     termsAndConditions: true
//   })
// )
